module.exports = __webpack_public_path__ + "media/images/p-newsArchiveAccordion/arrow-21c80311f21ebf1ebdfa1f5a7e1ab82e.svg";